'use strict';

var $bag = $('.header-account-bag');
var $cartSummary = $bag.find('.cart-summary-quantity');
var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');

var CartSummary = {
  hasSummary: false,

  getCount: function getCount() {
    if (!$cartSummary.length) {
      return false;
    }

    HTTPService.get('/api/carts/my/items/count')
      .then(HTTPService.handleClientError)
      .then(function (data) {
        CartSummary.setCount((data || {}).total);
      });
  },

  getSummary: function getSummary(withHover, fn) {
    if (!CartSummary.getCountFromStorage()) {
      fn && fn();
      return;
    }

    if (withHover && this.hasSummary) {
      fn && fn();
      return false;
    }

    this.hasSummary = true;

    HTTPService.get('/api/carts/my/items?html=true&partial=cart-summary&pageName=' + blz.pageName)
      .then(HTTPService.handleClientError)
      .then(function (data) {
        if (data) {
          $bag[0].innerHTML = data;
          fn && fn();
        }
      })
      .catch(NotificationService.warning);
  },

  fetchBag: function () {
    CartSummary.getCount();
    CartSummary.getSummary();
  },

  getCountFromStorage: function () {
    return (
      ('localStorage' in window &&
        (JSON.parse(window.localStorage.getItem('ngStorage-cart')) || {}).total) ||
      0
    );
  },

  setCount: function (total) {
    if (total) {
      $cartSummary.text(total);
      $cartSummary.removeClass('cart-summary-opacity0');
      'localStorage' in window &&
        localStorage.setItem('ngStorage-cart', JSON.stringify({ total: total }));
      $bag.find('.cart-summary-wrap').remove();
    }

    if (total === 0) {
      $cartSummary.text(total);
      'localStorage' in window &&
        localStorage.setItem('ngStorage-cart', JSON.stringify({ total: 0 }));
    }
  }
};

$(document).on('cart:getCount', CartSummary.getCount);
$(document).on('cart:getSummary', CartSummary.getSummary);
$(document).on('cart:setCount', function (_event, total) {
  CartSummary.setCount(total);
});
$(document).on('cart:fetchBag', CartSummary.fetchBag);
$('.js-cart-reset').on('click tap', function () {
  CartSummary.setCount(0);
});

CartSummary.getCount();

module.exports = CartSummary;
